import { render, staticRenderFns } from "./createDocument.vue?vue&type=template&id=6701c8cc&scoped=true"
import script from "./createDocument.vue?vue&type=script&lang=js"
export * from "./createDocument.vue?vue&type=script&lang=js"
import style0 from "./createDocument.vue?vue&type=style&index=0&id=6701c8cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6701c8cc",
  null
  
)

export default component.exports